import { Layouts } from '../../../controls/layouts';
import { Component, model, ChangeDetectionStrategy } from '@angular/core';
import { ContextPropertyFilterDto } from '../../models/context-property-filter-dto';
import { ControlContainer, NgForm, FormsModule } from '@angular/forms';
import { ContextPropertyFilterComponent } from '../context-property-filter/context-property-filter.component';
import { ExceptionCategory } from 'src/app/developer/models/exception-category';
import { DataField } from 'src/app/shared/datafields/models';
import { DistributionObjectGroup } from 'src/app/distribution/models/distribution-object-group';
import { DocumentTypeEntity } from 'src/app/distribution/models';
import { Tag } from 'src/app/tags/models';
import { LinkComponent } from '../../../controls/components/basic/link/link.component';

@Component({
    selector: 'app-context-property-filters',
    templateUrl: './context-property-filters.component.html',
    styleUrls: ['./context-property-filters.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [Layouts, FormsModule, ContextPropertyFilterComponent, LinkComponent]
})
export class ContextPropertyFiltersComponent {
  filters = model.required<ContextPropertyFilterDto[]>();
  readonly = model.required<boolean>();
  
  documentTypes: DocumentTypeEntity[];
  documentTypeGroups: DistributionObjectGroup[];
  exceptionCategories: ExceptionCategory[];
  partnerConfigurationKeys: DataField[];
  distributionConfigurationKeys: DataField[];
  partnerTags: Tag[];

  constructor() {
  }

  private getTempId(): number {
    return -Math.floor((Math.random() * 100000) + 1);
  }

  updateFilter(idx: number, filter: ContextPropertyFilterDto) {
    this.filters.update(c => {
      const newFilters = [...c];
      newFilters[idx] = filter;
      return newFilters;
    });
  }

  addFilter() {
    this.filters.update(c => [
      ...c,
      {
        Id: this.getTempId(),
        PropertyName: null,
        PropertyNamespace: null,
        Values: [{ Id: this.getTempId(), Value: null }]
      }
    ]);
  }

  deleteFilter(idx: number) {
    this.filters.update(c => {
      const newFilters = [...c];
      newFilters.splice(idx, 1)
      return newFilters;
    });
  }
}
